// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"03ec0ad91ecc7763","581":"64c565db7d6eddd4"}[chunkId] + ".js";
};